<form [nzAutoTips]="autoTips" nz-form [formGroup]="form">
    <nz-form-item>
        <nz-form-label nzRequired [nzFlex]="size.label">
            {{"User.AccountNumber" | translate}}
        </nz-form-label>
        <nz-form-control [nzFlex]="size.control">
            <input nz-input formControlName="userName">
        </nz-form-control>
    </nz-form-item>
    <nz-form-item>
        <nz-form-label [nzFlex]="size.label">
            {{"User.Name" | translate}}
        </nz-form-label>
        <nz-form-control [nzFlex]="size.control" [nzErrorTip]="realName">
            <input nz-input formControlName="realName">
            <ng-template #realName let-control>
                <ng-container
                    *ngIf="control.hasError('required')">{{'Validate.Required' | translate}}</ng-container>
                <ng-container
                    *ngIf="control.hasError('maxlength')">{{'Validate.MaxLength50' | translate}} [{{form.get('realName').value?.length}}]</ng-container>
            </ng-template>
        </nz-form-control>
    </nz-form-item>
    <nz-form-item>
        <nz-form-label [nzFlex]="size.label">
            {{"User.JobNumber" | translate}}
        </nz-form-label>
        <nz-form-control [nzFlex]="size.control" [nzErrorTip]="jobNumber">
            <input nz-input formControlName="jobNumber">
            <ng-template #jobNumber let-control>
                <ng-container *ngIf="control.hasError('pattern')">{{'Validate.InputFourDigit' | translate}}</ng-container>
            </ng-template>
        </nz-form-control>
    </nz-form-item>
    <nz-form-item>
        <nz-form-label [nzFlex]="size.label">
            {{'User.PhoneNumber' | translate}}
        </nz-form-label>
        <nz-form-control [nzFlex]="size.control">
            <input nz-input formControlName="phoneNumber" [maxlength]="100">
        </nz-form-control>
    </nz-form-item>
    <nz-form-item>
        <nz-form-label nzRequired [nzFlex]="size.label">
            {{'User.UserType' | translate}}
        </nz-form-label>
        <nz-form-control [nzSpan]="size.control">
            <nz-select [required] formControlName="userType" nzAllowClear>
                <nz-option *ngFor="let item of userTypeOptions" [nzValue]="item.label" [nzLabel]="item.value"></nz-option>
            </nz-select>
        </nz-form-control>
    </nz-form-item>
    <nz-form-item *ngIf="form.controls['userType'].value=== userTypeConstant.ManagementUser">
        <nz-form-label nzRequired [nzFlex]="size.label">
            {{'Login.Roles' | translate}}
        </nz-form-label>
        <nz-form-control [nzFlex]="size.control" [nzErrorTip]="'Login.Roles' | translate | requiredMessage">
            <nz-select formControlName="roles" nzAllowClear>
              <nz-option *ngFor="let item of roleList" [nzValue]="item.name" [nzLabel]="item.roleName"></nz-option>
            </nz-select>
        </nz-form-control>
    </nz-form-item>

</form>
<div *nzModalFooter>
    <button (click)="cancel()" type="button" nz-button>{{'Common.Cancel'|translate}}</button>
    <button (click)="save()" [disabled]="!form.valid" nz-button nzType="primary">{{'Common.Save'|translate}}</button>
</div>

